const validateCircleDraw = (text, ctx, circleDetails) => {
  const { centerX, centerY, radius, start, end } = circleDetails;

  // dont render empty string or transparent
  if (text.trim() === '' || ctx.globalAlpha === 0) return false;

  if (
    (end !== undefined && end !== null && isNaN(end))
    || isNaN(centerX)
    || isNaN(centerY)
    || isNaN(radius)
    || isNaN(start)
  ) {
    throw TypeError(
      'circle text arguments requires a number for centerX, centerY, radius, start, and end.'
    );
  }

  return true;
};

const calculateTextPosition = (ctx, text, circleDetails, forward, aligned) => {
  let dir = forward ? 1 : -1; // set dir if not true or false set forward as true
  let { start } = circleDetails;
  const { radius } = circleDetails;
  const pAS = 1 / radius; // get the angular size of a pixel in radians
  const textWidth = ctx.measureText(text).width; // get the width of all the text

  // if no end is supplied correct start and end for alignment
  // if forward is not given then swap top of circle text to read the correct direction
  if (
    (forward === null || forward === undefined)
    && ((start % (Math.PI * 2)) + Math.PI * 2) % (Math.PI * 2) > Math.PI
  ) {
    dir = -1;
  }
  const pA = -pAS * dir;
  const wScale = -1 * dir;
  // eslint-disable-next-line default-case
  switch (aligned) {
  case 'center': // if centered move around half width
    start -= (pA * textWidth) / 2;
    break;
  case 'right': // intentionally falls through to case "end"
  case 'end':
    start -= pA * textWidth;
    break;
  }

  return { wScale, pA, alteredStart: start };
};

// displays text along a circle
// ctx: canvas context
// text: string of text to measure
// circleDetails:
//    centerX, centerY: position of circle center
//    radius: radius of circle in pixels
//    start: angle in radians to start.
//    [end]: optional. If included text align is ignored and the text is
//        scaled to fit between start and end;
// [forward]: optional default true. if true text direction is forwards, if false  direction is backward
export function fillCircleText(ctx, text, circleDetails, forward) {
  validateCircleDraw(text, ctx, circleDetails);
  let a;
  let aw;
  const { centerX, centerY, radius } = circleDetails;
  const aligned = ctx.textAlign; // save the current textAlign so that it can be restored at end
  const { pA, wScale, alteredStart } = calculateTextPosition(
    ctx,
    text,
    circleDetails,
    forward,
    aligned
  );

  ctx.textAlign = 'center'; // align for rendering
  a = alteredStart; // set the start angle

  for (const character of text) {
    aw = ctx.measureText(character).width * pA; // get the angular width of the text
    const xDx = Math.cos(a + aw / 2); // get the yAxies vector from the center centerX,centerY out
    const xDy = Math.sin(a + aw / 2);
    ctx.save();
    ctx.transform(
      -xDy * wScale,
      xDx * wScale,
      xDy < 0 ? -xDx : xDx,
      xDy < 0 ? -xDy : xDy,
      xDx * radius + centerX,
      xDy * radius + centerY
    );
    ctx.fillText(character, 0, 0);
    ctx.restore();
    a += aw; // step to the next angle
  }

  ctx.textAlign = aligned; // restore the text alignment
}
